import { isNil } from 'es-toolkit';

let lastMemoryCheck = 0;
let memoryCheckInterval: number | undefined;

const MEMORY_GROWTH_THRESHOLD = 50;
const MEMORY_CHECK_INTERVAL = 5000;

const getJsHeapSize = (): number | undefined => {
  if (
    !('memory' in performance) ||
    typeof performance.memory !== 'object' ||
    !performance.memory ||
    !('usedJSHeapSize' in performance.memory) ||
    typeof performance.memory.usedJSHeapSize !== 'number'
  ) {
    // Right now, this only works in chromium-based browsers. But could also break at any moment...
    // Just fail silently not to bother the users each time. Alternatively we could log that it's not supported.
    return;
  }

  return performance.memory.usedJSHeapSize;
};

export const monitorMemoryUsage = (): (() => void) | undefined => {
  const initialMemory = getJsHeapSize();
  if (isNil(initialMemory)) return;
  if (!isNil(memoryCheckInterval)) return;

  lastMemoryCheck = initialMemory;
  console.info(
    `[BJS-RENDERER] Memory leak monitoring started (checking every ${MEMORY_CHECK_INTERVAL / 1000}s for >${MEMORY_GROWTH_THRESHOLD}MB growth)`,
  );

  memoryCheckInterval = setInterval(() => {
    const currentMemory = getJsHeapSize();
    if (isNil(currentMemory)) return;

    const memoryGrowthMB = (currentMemory - lastMemoryCheck) / 1024 / 1024;

    if (memoryGrowthMB > MEMORY_GROWTH_THRESHOLD) {
      console.error(
        `[BJS-RENDERER] POSSIBLE MEMORY LEAK DETECTED: Memory grew by ${memoryGrowthMB.toFixed(1)}MB in 5 seconds! Please investigate.`,
        `Previous: ${(lastMemoryCheck / 1024 / 1024).toFixed(1)}MB, Current: ${(currentMemory / 1024 / 1024).toFixed(1)}MB`,
      );
    }

    lastMemoryCheck = currentMemory;
  }, MEMORY_CHECK_INTERVAL) as unknown as number;

  // Cleanup function - should be called by the consumer.
  return () => {
    if (isNil(memoryCheckInterval)) return;

    clearInterval(memoryCheckInterval);
    memoryCheckInterval = undefined;
  };
};
